import $ from 'jquery';

Drupal.behaviors.beijertechgroupDataToggle = {
  attach: function (context) {
    const $button = $('[data-toggle]', context);

    $button.unbind().on('beijertechgroupDataToggle').on('click', function() {
      let regionID = $(this).attr('data-toggle'),
        $region = $('#' + regionID),
        ariaExpanded = $(this).attr('aria-expanded');

      $region.toggleClass('show');

      if (ariaExpanded === 'false') {
        $(this).attr('aria-expanded', 'true');
      } else if (ariaExpanded === 'true') {
        $(this).attr('aria-expanded', 'false');
      }
    });
  }
};
